<template>
    <section class="wrapper image-wrapper bg-content text-white" :style="{
        '--bg-image': `url(${bgGradient})`
    }">
        <div class="container pt-18 pb-16 position-relative z-10">
            <div class="row gx-0 gy-12 align-items-center">

                <!-- LEFT: Text -->
                <div class="col-md-10 offset-md-1 offset-lg-0 col-lg-6 content text-center text-lg-start">
                    <h2 class="display-2 mb-5 text-white">
                        In the world of business, creativity is the key that unlocks
                        doors to infinite opportunities.
                    </h2>

                    <div class="d-flex justify-content-center justify-content-lg-start">
                        <router-link :to="{ name: 'Company' }" class="btn btn-lg btn-secondary rounded-pill me-2"
                            style="color: #820358">
                            Learn More
                        </router-link>
                    </div>
                </div>

                <!-- RIGHT: Image -->
                <div class="col-lg-6 d-none d-lg-flex justify-content-end">
                    <img :src="learnMoreImg" alt="Learn More" class="img-fluid rounded"
                        style="max-height: 480px; object-fit: contain;" />
                </div>

            </div>
        </div>
    </section>
</template>

<script setup>
import bgGradient from '@/assets/img/bg-smilepicture.png'
import learnMoreImg from '@/assets/img/img-learnmore.png'
</script>

<style scoped>
.image-wrapper {
    position: relative;
}

.image-wrapper::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: var(--bg-image);
    background-size: cover;
    background-position: center;
    z-index: 0;
}

.z-10 {
    z-index: 10;
}
</style>
